// extracted by mini-css-extract-plugin
module.exports = {"container":"AccessKeyResult_container__1rWLC","column":"AccessKeyResult_column__1HDqi","item":"AccessKeyResult_item__2w9vq","link":"AccessKeyResult_link__3dvMo"};